import { ColumnDef } from '@tanstack/react-table'
import { SocialDataMock } from '@type/history.type'
import { Badge, Table2 } from '@ui'
import moment from 'moment'
import { useMemo } from 'react'
import { patientHistoryTableClassName } from '../Results/tableStyles'

export default function SocialHistoryTable({ isLoading, records }: { isLoading?: boolean; records: SocialDataMock[] }) {
  const columns = useMemo<ColumnDef<SocialDataMock>[]>(
    () => [
      {
        accessorKey: 'social',
        header: 'Socials',
        cell: ({ row }) => <span>{row.original.attributes.social_type || '-'}</span>
      },
      {
        accessorKey: 'name',
        header: 'Name',
        cell: ({ row }) => <span>{row.original.attributes.social_name || '-'}</span>
      },
      {
        accessorKey: 'status',
        header: 'Status',
        cell: ({ row }) => (
          <Badge label={row.original.attributes.status} size="small" status={row.original.attributes.status} />
        )
      },
      {
        accessorKey: 'startDate',
        header: 'Start Date',
        cell: ({ row }) => (
          <span>{row.original.attributes.date ? moment(row.original.attributes.date).format('DD/MM/YYYY') : '-'}</span>
        )
      }
    ],
    []
  )

  return (
    <Table2
      className={patientHistoryTableClassName}
      columns={columns}
      data={records}
      emptyDescription="No history found."
      isLoading={isLoading}
      message="No history found"
      showPagination={false}
      wrapperClass="overflow-x-auto"
    />
  )
}
